import {SpecialWorkSessionLimitUnit, WorksheetConstraintMode} from "../../../../constants/enums";
import {ApiResponse} from "../../../../../@bizkeytech";

// "id": "<uuid>",
//       "name": "<string>",
//       "qrCode": "<uuid>",
//       "worksheetConstraintMode": "<string>",
//       "workingSchedule": {
//         "monday": "<boolean>",
//         "tuesday": "<boolean>",
//         "wednesday": "<boolean>",
//         "thursday": "<boolean>",
//         "friday": "<boolean>",
//         "saturday": "<boolean>",
//         "sunday": "<boolean>"
//       },
//       "organizationLocations": [
//         {
//           "id": "<uuid>",
//           "name": "<string>",
//           "address": "<string>",
//           "latitude": "<double>",
//           "longitude": "<double>",
//           "radiusInMeters": "<double>"
//         },
//         {
//           "id": "<uuid>",
//           "name": "<string>",
//           "address": "<string>",
//           "latitude": "<double>",
//           "longitude": "<double>",
//           "radiusInMeters": "<double>"
//         }
//       ],
//       "organizationWorkPeriods": [
//         {
//           "id": "<uuid>",
//           "name": "<string>",
//           "startTime": "<time>",
//           "endTime": "<time>"
//         },
//         {
//           "id": "<uuid>",
//           "name": "<string>",
//           "startTime": "<time>",
//           "endTime": "<time>"
//         }
//       ],
//       "organizationHolidays": [
//         {
//           "id": "<uuid>",
//           "name": "<string>",
//           "date": "<date>"
//         },
//         {
//           "id": "<uuid>",
//           "name": "<string>",
//           "date": "<date>"
//         }
//       ],
//       "isGroupSettings": "<boolean>"


// *************************************************
// Get
// *************************************************

export interface GetOrganizationSettingsResponseDs_WorkingSchedule {
    monday: boolean,
    tuesday: boolean,
    wednesday: boolean,
    thursday: boolean,
    friday: boolean,
    saturday: boolean,
    sunday: boolean,
}

export const DefaultOrganizationWorkingSchedule: GetOrganizationSettingsResponseDs_WorkingSchedule = {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
}

export interface GetOrganizationSettingsResponseDs_OrganizationLocation {
    id?: string,
    name?: string,
    address?: string,
    latitude: number,
    longitude: number,
    radiusInMeters: number,
}

export interface GetOrganizationSettingsResponseDs_OrganizationWorkPeriod {
    id: string,
    name?: string,
    startTime?: string,
    endTime?: string,
}

export interface GetOrganizationSettingsResponseDs_OrganizationHoliday {
    id: string,
    name?: string,
    date?: string,
}

export interface GetOrganizationSettingsResponseDs_SpecialWorkSession {
    id: string,
    title?: string,
    description?: string,
    limit?: number,
    limitUnit?: SpecialWorkSessionLimitUnit;
}

export interface OrganizationSettingSectionFlags<T = boolean> {
    qrCodeEnabled?: T;
    worksheetConstraintModeEnabled?: T;
    organizationWorkingSchedulesEnabled?: T;
    organizationLocationsEnabled?: T;
    organizationWorkPeriodsEnabled?: T;
    organizationHolidaysEnabled?: T;
    specialWorkSessionsEnabled?: T;
}

export interface GetOrganizationSettingsResponseDs extends OrganizationSettingSectionFlags {
    id?: string,
    organizationGroupId?: string,
    name?: string,
    qrCode?: string,
    worksheetConstraintMode?: WorksheetConstraintMode,
    workingSchedule?: GetOrganizationSettingsResponseDs_WorkingSchedule,
    organizationLocations?: Array<GetOrganizationSettingsResponseDs_OrganizationLocation>,
    organizationWorkPeriods?: Array<GetOrganizationSettingsResponseDs_OrganizationWorkPeriod>,
    organizationHolidays?: Array<GetOrganizationSettingsResponseDs_OrganizationHoliday>,
    specialWorkSessions?: Array<GetOrganizationSettingsResponseDs_SpecialWorkSession>,
}

export type GetOrganizationSettingsResponse = ApiResponse<Array<GetOrganizationSettingsResponseDs>>;


// *************************************************
// Create
// *************************************************

export interface CreateOrganizationSettingsRequest extends OrganizationSettingSectionFlags {
    organizationGroupId?: string,
    name?: string,
    worksheetConstraintMode?: WorksheetConstraintMode,
}


export interface CreateOrganizationSettingsResponseDs {
    id: string,
    name: string,
    qrCode?: string,
    worksheetConstraintMode?: WorksheetConstraintMode,
}

export type CreateOrganizationSettingsResponse = ApiResponse<CreateOrganizationSettingsResponseDs>;


// *************************************************
// Update
// *************************************************


export interface UpdateOrganizationSettingsRequest extends OrganizationSettingSectionFlags {
    id: string,
    organizationGroupId?: string,
    name?: string,
    worksheetConstraintMode?: WorksheetConstraintMode,
}

export type UpdateOrganizationSettingsResponse = ApiResponse<void>;


// *************************************************
// Delete
// *************************************************

export interface DeleteOrganizationSettingsRequest {
    id: string,
    organizationGroupId?: string,
}

export type DeleteOrganizationSettingsResponse = ApiResponse<void>;


// *************************************************
// Create Holiday
// *************************************************

export interface CreateOrganizationSettingHolidayRequest {
    organizationSettingsId: string;
    name: string;
    date: string;
}

export interface CreateOrganizationSettingHolidayResponseDs {
    id: string;
    organizationSettingsId: string;
    name: string;
    date: string;
}

export type CreateOrganizationSettingHolidayResponse = ApiResponse<CreateOrganizationSettingHolidayResponseDs>;

// *************************************************
// Update Holiday
// *************************************************

export interface UpdateOrganizationSettingHolidayRequest {
    organizationSettingsId: string;
    id: string;
    name: string;
    date: string;
}

export type UpdateOrganizationSettingHolidayResponse = ApiResponse<void>;

// *************************************************
// Delete Holiday
// *************************************************

export interface DeleteOrganizationSettingHolidayRequest {
    id: string;
    organizationSettingsId: string;
}

export type DeleteOrganizationSettingHolidayResponse = ApiResponse<void>;


// *************************************************
// Create Location
// *************************************************

export interface CreateOrganizationSettingLocationRequest {
    organizationSettingsId: string;
    name: string;
    address: string;
    latitude: number;
    longitude: number;
    radiusInMeters: number;
}

export interface CreateOrganizationSettingLocationResponseDs {
    id: string;
    name: string;
    address: string;
    latitude: number;
    longitude: number;
    radiusInMeters: number;
    organizationSettingsId: string;
}

export type CreateOrganizationSettingLocationResponse = ApiResponse<CreateOrganizationSettingLocationResponseDs>;

// *************************************************
// Update Location
// *************************************************

export interface UpdateOrganizationSettingLocationRequest {
    organizationSettingsId: string;
    id: string;
    name: string;
    address: string;
    latitude: number;
    longitude: number;
    radiusInMeters: number;
}

export type UpdateOrganizationSettingLocationResponse = ApiResponse<void>;

// *************************************************
// Delete Location
// *************************************************

export interface DeleteOrganizationSettingLocationRequest {
    id: string;
    organizationSettingsId: string;
}

export type DeleteOrganizationSettingLocationResponse = ApiResponse<void>;


// *************************************************
// Regenerate QR Code
// *************************************************

export interface RegenerateOrganizationSettingQrCodeRequest {
    organizationSettingsId: string;
}


export interface RegenerateOrganizationSettingQrCodeResponseDs {
    id: string,
    name: string,
    qrCode: string,
    worksheetConstraintMode?: WorksheetConstraintMode,
}

export type RegenerateOrganizationSettingQrCodeResponse = ApiResponse<RegenerateOrganizationSettingQrCodeResponseDs>;


// *************************************************
// Create Special Work Session
// *************************************************

export interface CreateOrganizationSettingSpecialWorkSessionRequest {
    organizationSettingsId: string;
    title: string,
    description?: string,
    limit: number,
    limitUnit: SpecialWorkSessionLimitUnit;
}

export interface CreateOrganizationSettingSpecialWorkSessionResponseDs {
    id: string;
    organizationSettingsId: string;
    title: string,
    description?: string,
    limit: number,
    limitUnit: SpecialWorkSessionLimitUnit;
}

export type CreateOrganizationSettingSpecialWorkSessionResponse = ApiResponse<CreateOrganizationSettingSpecialWorkSessionResponseDs>;

// *************************************************
// Update Special Work Session
// *************************************************

export interface UpdateOrganizationSettingSpecialWorkSessionRequest {
    organizationSettingsId: string;
    id: string;
    title: string,
    description?: string,
    limit: number,
    limitUnit: SpecialWorkSessionLimitUnit;
}

export type UpdateOrganizationSettingSpecialWorkSessionResponse = ApiResponse<void>;

// *************************************************
// Delete Special Work Session
// *************************************************

export interface DeleteOrganizationSettingSpecialWorkSessionRequest {
    id: string;
}

export type DeleteOrganizationSettingSpecialWorkSessionResponse = ApiResponse<void>;


// *************************************************
// Create Work Period
// *************************************************

export interface CreateOrganizationSettingWorkPeriodRequest {
    organizationSettingsId: string;
    startTime: string,
    endTime: string,
}

export interface CreateOrganizationSettingWorkPeriodResponseDs {
    id: string;
    organizationSettingsId: string;
    startTime: string,
    endTime: string,
}

export type CreateOrganizationSettingWorkPeriodResponse = ApiResponse<CreateOrganizationSettingWorkPeriodResponseDs>;

// *************************************************
// Update Work Period
// *************************************************

export interface UpdateOrganizationSettingWorkPeriodRequest {
    id: string;
    organizationSettingsId: string;
    startTime: string,
    endTime: string,
}

export type UpdateOrganizationSettingWorkPeriodResponse = ApiResponse<void>;

// *************************************************
// Delete Work Period
// *************************************************

export interface DeleteOrganizationSettingWorkPeriodRequest {
    id: string;
    organizationSettingsId: string;
}

export type DeleteOrganizationSettingWorkPeriodResponse = ApiResponse<void>;


// *************************************************
// Create Working Schedule
// *************************************************

export interface CreateOrganizationSettingWorkingScheduleRequest {
    organizationSettingsId: string;
    monday: boolean,
    tuesday: boolean,
    wednesday: boolean,
    thursday: boolean,
    friday: boolean,
    saturday: boolean,
    sunday: boolean,
}

export type CreateOrganizationSettingWorkingScheduleResponse = ApiResponse<void>;

// *************************************************
// Update Working Schedule
// *************************************************

export interface UpdateOrganizationSettingWorkingScheduleRequest {
    organizationSettingsId: string;
    monday: boolean,
    tuesday: boolean,
    wednesday: boolean,
    thursday: boolean,
    friday: boolean,
    saturday: boolean,
    sunday: boolean,
}

export type UpdateOrganizationSettingWorkingScheduleResponse = ApiResponse<void>;

// *************************************************
// Delete Working Schedule
// *************************************************

export interface DeleteOrganizationSettingWorkingScheduleRequest {
    organizationSettingsId: string;
}

export type DeleteOrganizationSettingWorkingScheduleResponse = ApiResponse<void>;
